import * as React from 'react'
import SVG from 'react-svg-inline'
import styled from 'styled-components'
import { Styled } from './styled'

const Input = styled.input`
  font-size: 16px;
  width: 100%;
  height: 60px;
  color: ${props => props.theme.color.mainFont};
  background-color: ${props => props.theme.color.background};
  border-radius: 10px;
  padding-left: ${props => (props.icon ? '55px' : '20px')};
  outline: none;
  border: none;
  display: flex;

  &::placeholder {
    color: ${props => props.theme.color.disabled};
  }

  &:hover:not(:focus):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    border: 1px solid ${props => props.theme.color.pale};
  }

  &:focus {
    background-color: ${props => props.theme.color.backgroundRush};
    border: 1px solid ${props => props.theme.color.background};
    padding-left: ${props => (props.icon ? '54px' : '19px')};

    & ~ span svg {
      fill: ${props => props.theme.color.gray};
    }
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

const Icon = styled(SVG)`
  display: flex;
  position: absolute;
  left: 20px;
  top: 20px;
  svg {
    transition: all ${p => p.theme.duration.s} linear;
    height: 20px;
    width: 20px;
    fill: ${props =>
      props.value ? props.theme.color.gray : props.theme.color.disabled};
  }
`

export default ({
  width,
  input,
  type,
  placeholder,
  autoFocus,
  autoComplete,
  maxLength,
  icon
}) => {
  const inputProps = {
    ...input,
    type,
    placeholder,
    autoFocus,
    autoComplete,
    maxLength
  }
  const { value } = input
  return (
    <Styled.InputContainer width={width}>
      <Input icon={icon} {...inputProps} />
      {icon && <Icon value={value} svg={icon} />}
    </Styled.InputContainer>
  )
}
